import React, { Component } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";

import { v4 as uuidv4 } from "uuid";
import {
  Container,
  Col,
  Form,
  FormGroup,
  Spinner,
  Button,
} from "react-bootstrap";
import AsyncSelect from "react-select/async";

import {
  GetClusters,
  GetAreas,
  GetBranchByCode,
} from "../../../../store/actions/crdm_service_actions";

import {
  GetPackageAreaV4,
  GetPackageClusterV4,
  GetPackageOverallV4,
  GetPackageBranchV4,
} from "../../../../store/actions/reports-v4/package_service_actions";

import { connect } from "react-redux";
import moment from "moment";
import { closeModal } from "../../../../store/actions/ModalActions";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { SetChartPackagesTitle } from "../../../../store/actions/reports/chart_title_actions";
import { toastr } from "react-redux-toastr";

const createData = (uuid, from, to) => {
  return { uuid, from, to };
};

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

class PackageViewFilter extends Component {
  state = {
    clusters: [],
    areas: [],
    branches: [],

    from: fromDate,
    to: toDate,

    isBusy: false,
    isRunningBalance: false,

    toView: "overall",
    previewText: "All Clusters",
    isClusterLoading: false,
    isAreaLoading: false,

    clusterSelectContext: null,
    areaSelectContext: null,

    clusterId: null,
    areaId: null,
    date: Date.now(),
  };

  componentDidMount() {
    this.openLoading();

    this.props.GetClusters().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isClusterLoading: false, clusters: resp.data });
      }
    });

    this.props.GetAreas().then((resp) => {
      if (resp.problem === null) {
        this.setState({ isAreaLoading: false, areas: resp.data });
      }
    });

    this.closeLoading();
  }

  openLoading = () => {
    this.setState({ isClusterLoading: true, isAreaLoading: true });
  };
  closeLoading = () => {
    this.setState({ isClusterLoading: false, isAreaLoading: false });
  };

  handleCluster = (d) => {
    this.setState({
      clusterId: d.target.value.id,
      clusterSelectContext: d.target.value,
    });
  };

  handleArea = (d) => {
    this.setState({
      areaId: d.target.value.areaCode,
      areaSelectContext: d.target.value,
    });
  };

  createFilterDate = () => {
    let { dates } = this.state;
    dates.push(createData(uuidv4(), Date.now(), Date.now()));
    this.setState({ dates });
  };

  handleRadioChanged = (e) => {
    this.setState({
      toView: e.target.value,
      clusterId: null,
      areaId: null,
      areaSelectContext: null,
      clusterSelectContext: null,
    });

    switch (e.target.value) {
      case "clusters":
        this.setState({ previewText: "All Clusters" });
        break;

      case "areas":
        this.setState({ previewText: "All Areas" });

        break;
      default:
        this.setState({ previewText: "No Values" });
        break;
    }
  };

  handleCoveredDate = (fieldData) => {
    this.setState({ date: fieldData });
  };

  //date range
  handleFrom = (fieldData) => {
    this.setState({ from: fieldData });
  };

  handleTo = (fieldData) => {
    this.setState({ to: fieldData });
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code);
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        if (resp.problem === null) {
          if (resp.data && resp.data.length > 0) {
            const currentItem = resp.data[0];
            return callback([
              {
                label: `(${currentItem.branchCode}) ${currentItem.branchName}`,
                value: currentItem.branchCode,
              },
            ]);
          }

          return callback([]);
        }

        return callback([]);
      });
    } else {
      return callback([]);
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branches: fieldData });
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  renderBranches = () => {
    return (
      <FormControl variant="filled" fullWidth>
        <AsyncSelect
          isMulti={true}
          placeholder="Enter Branch Codes"
          cacheOptions
          defaultOptions
          onChange={this.handlebranchCode}
          loadOptions={this.loadOptions}
        />
      </FormControl>
    );
  };

  renderClusters = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Cluster</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.clusterSelectContext}
          onChange={this.handleCluster}
        >
          {this.state.clusters.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                <span>{data.name} </span>
                <span className="text-danger ml-2 bold">{data.code}</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  renderAreas = () => {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
        <Select
          id="demo-simple-select-outlined"
          disabled={!this.state.toView === "clusters"}
          value={this.state.areaSelectContext}
          onChange={this.handleArea}
        >
          {this.state.areas.map((data, key) => {
            return (
              <MenuItem value={data} key={key}>
                {`${data.areaName}`}
                <span className="text-danger">({data.areaCode})</span>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  render() {
    return (
      <Container>
        <Form>
          <Form.Row>
            <FormGroup as={Col}>
              <FormControl className="d-inline">
                <RadioGroup
                  row
                  value={this.state.toView}
                  onChange={this.handleRadioChanged}
                >
                  <FormControlLabel
                    value="overall"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="overall"
                        name="radio-button"
                      />
                    }
                    label="Overall"
                  />
                  <FormControlLabel
                    value="clusters"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="clusters"
                        name="radio-button"
                      />
                    }
                    label="Clusters"
                  />
                  <FormControlLabel
                    value="areas"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="areas"
                        name="radio-button"
                      />
                    }
                    label="Areas"
                  />
                  <FormControlLabel
                    value="branches"
                    control={
                      <Radio
                        size="small"
                        color="primary"
                        value="branches"
                        name="radio-button"
                      />
                    }
                    label="Branches"
                  />
                </RadioGroup>
              </FormControl>
            </FormGroup>
          </Form.Row>

          <Form.Row>
            <FormGroup as={Col}>
              <Form.Check
                style={{ zIndex: 0 }}
                id="isRunningBalance"
                checked={this.state.isRunningBalance}
                onChange={(e) => {
                  this.setState({
                    isRunningBalance: e.target.checked,
                  });
                }}
                className="float-right"
                type="switch"
                label="Specific period"
              />
            </FormGroup>
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>{this.renderFilterView()}</FormGroup>
          </Form.Row>
          <Form.Row>
            {this.state.isRunningBalance ? (
              <>
                <FormGroup as={Col}>
                  <DatePicker
                    disableToolbar
                    fullWidth
                    autoOk
                    disableFuture
                    label="From"
                    variant="inline"
                    inputVariant="outlined"
                    format="MMMM DD YYYY"
                    openTo="year"
                    views={["year", "month", "date"]}
                    showTodayButton
                    value={this.state.from}
                    onChange={this.handleFrom}
                  />
                </FormGroup>

                <FormGroup as={Col}>
                  <DatePicker
                    disableToolbar
                    fullWidth
                    autoOk
                    disableFuture
                    label="To"
                    variant="inline"
                    inputVariant="outlined"
                    format="MMMM DD YYYY"
                    openTo="year"
                    views={["year", "month", "date"]}
                    showTodayButton
                    value={this.state.to}
                    onChange={this.handleTo}
                  />
                </FormGroup>
              </>
            ) : (
              <FormGroup as={Col}>
                <DatePicker
                  disableToolbar
                  fullWidth
                  autoOk
                  disableFuture
                  label="Covered Date"
                  variant="inline"
                  inputVariant="outlined"
                  format="MMMM DD YYYY"
                  openTo="year"
                  views={["year", "month", "date"]}
                  showTodayButton
                  value={this.state.date}
                  onChange={this.handleCoveredDate}
                />
              </FormGroup>
            )}
          </Form.Row>
          <Form.Row>
            <FormGroup as={Col}>
              <Button
                disabled={this.state.isBusy}
                onClick={() => {
                  this.setState({ isBusy: true });
                  let { clusterId, areaId, isRunningBalance } = this.state;
                  if (isRunningBalance) {
                    if (this.state.toView === "overall") {
                      this.PremiseGetDailyOverallPackage().then((result) => {
                        if (result.problem === null) {
                          this.props.Refresh();
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                    }
                    if (this.state.toView === "clusters") {
                      if (clusterId !== null) {
                        this.PremiseGetDailyClusterPackage(clusterId).then(
                          (result) => {
                            if (result.problem === null) {
                              this.props.Refresh();
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify a cluster to proceed.`, {
                          disableCancel: true,
                        });

                        this.setState({ isBusy: false });
                      }
                    }
                    if (this.state.toView === "areas") {
                      if (areaId !== null) {
                        this.PremiseGetDailyAreaPackage(areaId).then(
                          (result) => {
                            if (result.problem === null) {
                              this.props.Refresh();
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify area to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                    }
                    if (this.state.toView === "branches") {
                      if (this.state.branches.length > 0) {
                        this.PremiseGetDailyBranchPackage(
                          this.state.branches.map((item) => item.value)
                        ).then((result) => {
                          if (result.problem === null) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify a branch to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                    }
                  } else {
                    if (this.state.toView === "overall") {
                      this.PremiseGetOverallPackage().then((result) => {
                        if (result.problem === null) {
                          this.props.Refresh();
                          closeModal();
                        } else {
                          this.setState({ isBusy: false });
                        }
                      });
                    }
                    if (this.state.toView === "clusters") {
                      if (clusterId !== null) {
                        this.PremiseGetClusterPackage(clusterId).then(
                          (result) => {
                            if (result.problem === null) {
                              this.props.Refresh();
                              closeModal();
                            } else {
                              this.setState({ isBusy: false });
                            }
                          }
                        );
                      } else {
                        toastr.confirm(`Please specify a cluster to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                    }
                    if (this.state.toView === "areas") {
                      if (areaId !== null) {
                        this.PremiseGetAreaPackage(areaId).then((result) => {
                          if (result.problem === null) {
                            this.props.Refresh();
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify area to proceed.`, {
                          disableCancel: true,
                        });

                        this.setState({ isBusy: false });
                      }
                    }
                    if (this.state.toView === "branches") {
                      if (this.state.branches.length > 0) {
                        this.PremiseGetBranchPackage(
                          this.state.branches.map((item) => item.value)
                        ).then((result) => {
                          if (result.problem === null) {
                            closeModal();
                          } else {
                            this.setState({ isBusy: false });
                          }
                        });
                      } else {
                        toastr.confirm(`Please specify a branch to proceed.`, {
                          disableCancel: true,
                        });
                        this.setState({ isBusy: false });
                      }
                    }
                  }
                }}
                className="mt-2 float-right"
              >
                {!this.state.isBusy ? (
                  "View"
                ) : (
                  <Spinner size="sm" animation="border" />
                )}
              </Button>
            </FormGroup>
          </Form.Row>
        </Form>
      </Container>
    );
  }

  getAssignedDates = () => {
    return {
      from: moment(this.state.from).format("YYYY-MM-DD"),
    };
  };

  getAssignedDailyDates = () => {
    return {
      from: moment(this.state.from).format("YYYY-MM-DD"),
      to: moment(this.state.to).format("YYYY-MM-DD"),
    };
  };

  PremiseGetOverallPackage = () => {
    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.overall,
      moment(this.state.date).format("MMMM DD YYYY"),
      moment(this.state.date).format("MMMM DD YYYY")
    );

    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageOverallV4({
      dates: {
        from: this.state.date,
      },
      isRange: false,
    });
  };

  PremiseGetClusterPackage = (clusterId) => {
    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.specifiedCluster,
      moment(this.state.date).format("MMMM DD YYYY"),
      moment(this.state.date).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`,
      null
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageClusterV4({
      dates: {
        from: this.state.date,
      },
      clusterId: clusterId,
      isRange: false,
    });
  };

  PremiseGetAreaPackage = (areaId) => {
    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.specifiedArea,
      moment(this.state.date).format("MMMM DD YYYY"),
      moment(this.state.date).format("MMMM DD YYYY"),
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageAreaV4({
      dates: {
        from: this.state.date,
      },
      areaId: areaId,
      isRange: false,
    });
  };

  PremiseGetBranchPackage = (branch_codes) => {
    var chartTitle = renderChartTitle(
      moduleNames.branchCategory,
      OperationScope.specifiedBranch,
      moment(this.state.date).format("MMMM DD YYYY"),
      moment(this.state.date).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageBranchV4({
      dates: {
        from: this.state.date,
      },
      branch_codes: branch_codes,
      isRange: false,
    });
  };

  //.....

  PremiseGetDailyOverallPackage = () => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.overall,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY")
    );

    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageOverallV4({
      dates: dates,
      isRange: true,
    });
  };

  PremiseGetDailyClusterPackage = (clusterId) => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.specifiedCluster,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      `${this.state.clusterSelectContext.name} (${this.state.clusterSelectContext.code})`,
      null
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageClusterV4({
      dates: dates,
      clusterId: clusterId,
      isRange: true,
    });
  };

  PremiseGetDailyAreaPackage = (areaId) => {
    var dates = this.getAssignedDailyDates();

    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.specifiedArea,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      null,
      `${this.state.areaSelectContext.areaName} (${this.state.areaSelectContext.areaCode})`
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageAreaV4({
      dates: dates,
      areaId: areaId,
      isRange: true,
    });
  };

  PremiseGetDailyBranchPackage = (branch_codes) => {
    var dates = this.getAssignedDailyDates();
    var chartTitle = renderChartTitle(
      moduleNames.packages,
      OperationScope.specifiedBranch,
      moment(dates.from).format("MMMM DD YYYY"),
      moment(dates.to).format("MMMM DD YYYY"),
      null,
      null,
      `Branch (${branch_codes})`
    );
    this.props.SetChartPackagesTitle(chartTitle);

    return this.props.GetPackageBranchV4({
      dates: dates,
      branch_codes: branch_codes,
      isRange: true,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetClusters: GetClusters,
  GetAreas: GetAreas,
  SetChartPackagesTitle: SetChartPackagesTitle,
  GetPackageAreaV4: GetPackageAreaV4,
  GetPackageClusterV4: GetPackageClusterV4,
  GetPackageOverallV4: GetPackageOverallV4,
  GetBranchByCode: GetBranchByCode,
  GetPackageBranchV4: GetPackageBranchV4,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageViewFilter);
